<template>
  <div :class="{'v-hidden':!showCarousel}" class="cpj-index_featureLogo">
    <no-ssr>
      <swiper :options="swiperOptions">
        <swiper-slide v-for="item in list" :key="item.id" class="swiper-slide">
          <a :href="item.link" target="_blank">
            <img :src="item && item.logo ? item.logo : '/asset/image/logo/color-blind.svg'" :alt="item.companyname" class="img-fluid">
          </a>
        </swiper-slide>
      </swiper>
    </no-ssr>
  </div>
</template>
<script>

export default {
  props: {
    type: {
      type: String,
      default: 'page'
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: function () {
    return {
      showCarousel: true,
      list: []
    }
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 4,
        autoplay: {
          delay: 23000,
          disableOnInteraction: false
        },
        loop: false,
        spaceBetween: 20,
        height: 100,
        breakpoints: {
          0: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10
          }
        }
      }
    }
  },
  mounted() {
    const list = []
    Object.assign(list, this.data)
    this.list = list
  }
}

</script>
<style lang="scss">
  .cpj-index_featureLogo{
    @media screen and (max-width: 587px){
      .swiper-wrapper{
        align-items: center;
      }
      img{
        height: auto;
        max-height: 90px;
      }
    }
  }
</style>
